import Vue from 'vue'
import Vuex from 'vuex'
import VueRouter from 'vue-router'
import VueMaterial from 'vue-material'

import App from './components/App.vue'
import Home from './components/Home.vue'
// import About from './components/Aboutme.vue'

//store
import * as types from './store/mutationTypes'

require("../node_modules/vue-material/dist/vue-material.css")

// require("../node_modules/vue-material/dist/components/mdCore/index.css")
// require("../node_modules/vue-material/dist/components/mdButton/index.css")
// require("../node_modules/vue-material/dist/components/mdIcon/index.css")
// require("../node_modules/vue-material/dist/components/mdToolbar/index.css")
// require("../node_modules/vue-material/dist/components/mdAvatar/index.css")
// require("../node_modules/vue-material/dist/components/mdCard/index.css")
// require("../node_modules/vue-material/dist/components/mdList/index.css")
// require("../node_modules/vue-material/dist/components/mdWhiteframe/index.css")
// require("../node_modules/vue-material/dist/components/mdMenu/index.css")

require("../node_modules/flexboxgrid/dist/flexboxgrid.css")

Vue.use(VueRouter)
Vue.use(Vuex)
Vue.use(VueMaterial)

Vue.material.registerTheme('default', {
	primary: {
		color: 'teal',
		hue: 900
	},
	accent: {
		color: 'amber',
		hue: 'A400'
	},
	warn: 'deep-orange'
})

Vue.material.registerTheme('cards', {
	primary: {
		color: 'light-green',
		hue: 50
	},
	accent: {
		color: 'light-green',
		hue: 'A100'
	},
	warn: {
		color: 'amber',
		hue: 'A400'
	},
	background: {
		color: 'blue-grey',
		hue: 100
	}
})

const store = new Vuex.Store({
	state: {
		pageName: "app-main"
	},
	actions: {
		
	},
	getters: {

	},
	modules: {
		
	},
	mutations: {
		
	}
})

//------------ Routing App

const router = new VueRouter({
	mode: 'history',
	base: __dirname,
	routes: [
		{ path: '/', component: App,
			children: [
				{
					path: '/',
					components: {
						page: Home
					}
				},
				{
					path: '/aboutme',
					components: {
						page: resolve => System.import('./components/Aboutme.vue')
						// page : About
					}
				}
			]
		}
	]
})

const app = new Vue({
  router,
  store,
  template: '<router-view class="view"></router-view>'
}).$mount('#app')



// WEBPACK FOOTER //
// ./src/main.js